export default "__VITE_ASSET__ebe1f034__"